"use client";

import Link from "next/link";

import React, { useEffect, useState } from "react";
import { Tooltip, TooltipPosition, TooltipType } from "@/app/(components)/generics/Tootlip/Tooltip";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { DefaultProps } from "@/app/types/common/DefaultProps";

type Props = DefaultProps & {
  button: React.ReactNode;
  value: string;
  tooltipPosition?: TooltipPosition;
  tooltipPortal?: boolean;
};

export default function CopyButton({
  button,
  value,
  tooltipPosition = TooltipPosition.TOP,
  tooltipPortal = false,
}: Props) {
  const T = useT();

  const [copied, setCopied] = useState(false);
  let timeoutId: number | undefined;

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();

    if (value) {
      navigator.clipboard.writeText(value).then(() => {
        setCopied(true);

        if (timeoutId) {
          clearTimeout(timeoutId);
        }

        timeoutId = window.setTimeout(() => {
          setCopied(false);
        }, 1000);
      });
    }
  };

  useEffect(() => {
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [timeoutId]);

  return (
    <Tooltip
      position={tooltipPosition as TooltipPosition}
      portal={tooltipPortal}
      trigger={
        <Link href="" onClick={handleClick}>
          {button}
        </Link>
      }
      content={copied ? `${T(TKey.COPIED)} !` : T(TKey.COPY)}
      type={TooltipType.GREEN}
    />
  );
}
